import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetKeywordsInfo = (id) => {
  const data = useQuery(
    ["documentKeyWord", id],
    () =>
      axiosClient.get(
        `/DocumentTypeKey/GetDocumentKeyWordById?documentKeyId=${id}`
      ),
      { enabled: !!id }
  );

  return data;
};
export default useGetKeywordsInfo;
